// Etichette dei tipi di documento di carico (v3.7.0).
// A DB i codici restano IM7/IM4: all'utente si mostra la nomenclatura ADM
// attuale (H2 = deposito doganale, H1 = immissione in libera pratica) con il
// vecchio nome tra parentesi, ancora usato dagli operatori.

export const DOCUMENT_TYPE_LABELS: Record<string, string> = {
  IM7: 'H2 (IM7)',
  IM4: 'H1 (IM4)',
  T1: 'T1',
  DDT: 'DDT',
  PACKING_LIST: 'Packing List',
  ALTRO: 'Altro',
};

export const documentTypeLabel = (type?: string | null): string =>
  type ? (DOCUMENT_TYPE_LABELS[type] || type) : '';

export const DOCUMENT_TYPE_COLORS: Record<string, string> = {
  T1: 'red',
  IM7: 'blue',
  IM4: 'purple',
  DDT: 'green',
  PACKING_LIST: 'cyan',
  ALTRO: 'gold',
};

export const documentTypeColor = (type?: string | null): string =>
  (type && DOCUMENT_TYPE_COLORS[type]) || 'default';
